import { AddButton } from 'components/Buttons';
import styled from 'styled-components';

export const StyledAddDepartmentButton = styled(AddButton)`
  margin-top: 12px;
`;

export const DepartmentsBodyContainer = styled.div<{ emptyState?: boolean }>`
  display: flex;
  flex-direction: column;
  align-items: ${(props) => (props.emptyState ? 'center' : 'flex-start')};
  margin-bottom: ${(props) => (props.emptyState ? '24px' : 'none')};
`;

export const EmptyDepartmentsContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 8px;
  margin-top: 32px;
  margin-bottom: 18px;
  text-align: center;
  white-space: pre-line;
`;
